<template>
    <div class="cart_order_department_box">
        <el-row :gutter="20">
            <el-col :span="6"
            v-if="!power.includes(111)">
                <div>{{$t("message.cart.branch1")}}</div>
                <el-select
                    style="width:100%"
                    v-model="select_department"
                    @change="handleSend"
                    filterable
                    clearable
                    :disabled="cart_department.length && cart_department.length == 1">
                    <el-option
                        v-for="(item, index) in cart_department"
                        :key="index"
                        :label="item.department_code + ',' + item.departmentname"
                        :value="item.department_id">
                        <span class="cart_order_department_lf">{{item.department_code}},{{item.departmentname}}</span>
                        <span class="cart_order_department_rt">{{item.branchname}}</span>
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="12">
                <div>{{$t("message.cart.branch2")}}</div>
                <el-input
                    v-model="remark"
                    @change="handleSend">
                </el-input>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Bus from '@/utils/Bus'

export default {
    data() {
        return {
            select_department: "", // 选中部门id
            remark: "", // 备注
        }
    },
    computed: mapState({
        cart_department: state => state.order.cart_department,
        power: state => state.user.power
    }),
    methods: {
        setDepartment(val){
            if(val.length == 1){
                this.select_department = val[0].department_id
            }
        },
        handleSend(){
            Bus.$emit("cartOrderDepartment", {
                department: this.select_department,
                remark: this.remark
            })
        }
    },
    deactivated() {
        this.select_department = "";
        this.remark = "";
    },
    watch: {
        cart_department: {
            handler: "setDepartment",
            immediate: true
        }
    },
}
</script>

<style scoped>
.cart_order_department_box{
    margin-top: 15px;
}
/* 下拉框内容 */
.cart_order_department_lf,
.cart_order_department_rt{
    display: inline-block;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.cart_order_department_lf{
    float: left;
}
.cart_order_department_rt{
    float: right;
    color: #C0C4CC;
    font-size: 13px;
}
</style>
